import { RootState } from "@/app/stores";
import { getFoundations, IFoundation } from "@/shared/api/social-programs";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchFoundations = createAsyncThunk<
    IFoundation[],
    void,
    { state: RootState }
>('foundations/fetchFoundations', async (_, thunkAPI) => {
    try {
        const data = await getFoundations()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})